export enum ContactMethod {
    'phone' = 'phone',
    'address' = 'address',
}

export interface ContactCategory {
    created_at: string;
    id: number;
    pivot: ContactCategoryPivot;
    type: string;
    updated_at: string;
}

export interface ContactCategoryPivot {
    contact_method_id: number;
    contact_category_id: number;
    created_at: string;
    updated_at: string;
}

export interface ContactData {
    city: string;
    contact_categories: ContactCategory[];
    contactable_id?: number | null;
    contactable_type: string;
    country: string;
    created_at: string;
    hasMandatoryType: boolean;
    mandatoryTypes: string[] | null;
    id: number;
    latitude: number | null;
    longitude: number | null;
    method: ContactMethod;
    note: string;
    postal_code: string;
    province: string;
    street_address_1: string;
    street_address_2: string | null;
    type: string[];
    updated_at: string;
    value: string;
    verified_at: string;
}

export type ContactMethods = Record<ContactMethod, ContactData[]>;

export interface AddressFormDrawerProps {
    drawerText: string;
    isDrawerVisible: boolean;
    setDrawerVisible: (visible: boolean) => void;
    address: ContactData | null;
    contactableID?: number | null;
    contactableType: 'profile' | 'company';
}

export interface PhoneNumber {
    type: string;
    number: string;
    id: number;
    formattedNumber?: string;
    error: string;
    isValid: boolean;
}

export interface Contactable {
  id?: number | null;
  contactableType?: 'profile' | 'company';
}
